import { useMutation } from "hooks/useQueries";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { UserRoleTypes } from "utils/common";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

export const ProfileAPI = () => {
  const userData = useAppSelector((state) => state?.user?.userData);

  const navigate = useNavigate();

  const { mutate: handleUpdateProfile, isLoading: updateProfileUpdateLoading } =
    useMutation({
      mutationFn: (data: any) =>
        axiosInstance.patch(`/personal-details-update/${userData?.id}/`, data),
      onSuccess: () => {
        refetchQuery(QueryKeys.GET_USER_DETAIL);
      },
    });

  const {
    mutate: handleUpdateProfileRole,
    isLoading: updateRoleUpdateLoading,
  } = useMutation({
    mutationFn: (data: any) =>
      axiosInstance.post(`/user-role/`, { userRole: data }),
    onSuccess: () => {
      navigate(`/app/holdings`);
      window?.location?.reload();
    },
  });
  const {
    mutate: handlePartnerCompany,
    isLoading: updatePartnerCompanyLoading,
  } = useMutation({
    mutationFn: (id: number) =>
      axiosInstance.patch("/user-role/update-partner-company/", {
        partnerCompany: id,
      }),
    onSuccess: () => {
      handleUpdateProfileRole(UserRoleTypes.partner);
    },
  });

  return {
    handleUpdateProfile,
    updateProfileUpdateLoading,
    handleUpdateProfileRole,
    updateRoleUpdateLoading,
    handlePartnerCompany,
    updatePartnerCompanyLoading,
  };
};
